import { render } from "./PasswordReminderResetView.vue?vue&type=template&id=12c537f9&scoped=true&ts=true"
import script from "./PasswordReminderResetView.vue?vue&type=script&lang=ts"
export * from "./PasswordReminderResetView.vue?vue&type=script&lang=ts"

import "./PasswordReminderResetView.vue?vue&type=style&index=0&id=12c537f9&scoped=true&lang=css"

import exportComponent from "C:\\Dmes\\webdds-src\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12c537f9"]])

export default __exports__